import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="px-6 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          重磅推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          当前最值得看的热门综艺精选
        </p>
        <div className="flex flex-col gap-5">
          {carouselData.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group relative bg-background-50 rounded-2xl overflow-hidden flex flex-col md:flex-row cursor-pointer"
            >
              <div className="md:w-[320px] lg:w-[400px] flex-shrink-0 aspect-video md:aspect-auto relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className={`text-xs px-3 py-1 rounded-full font-semibold text-white ${
                    item.badge === '热播中' ? 'bg-primary-500' : 'bg-accent-500'
                  }`}>
                    {item.badge}
                  </span>
                </div>
              </div>
              <div className="flex-1 p-6 md:p-8 flex flex-col justify-center">
                <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium mb-3 self-start">
                  {item.tag}
                </span>
                <h3 className="text-xl md:text-2xl font-heading text-foreground-950 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 font-medium mb-3">
                  {item.subtitle}
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {item.description}
                </p>
                <span className="inline-flex items-center gap-1 text-sm font-semibold text-primary-500 group-hover:gap-2 transition-all whitespace-nowrap">
                  立即观看 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}